import { render, staticRenderFns } from "./ExpansionCard.vue?vue&type=template&id=afd90a98"
import script from "./ExpansionCard.vue?vue&type=script&lang=js"
export * from "./ExpansionCard.vue?vue&type=script&lang=js"
import style0 from "./ExpansionCard.vue?vue&type=style&index=0&id=afd90a98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports